module.exports = __webpack_public_path__ + "assets/rili.4c08d024fb4950e3c9e4eea7f3c728ef.png";